import { createFileRoute } from "@tanstack/react-router";

import TestPortalHostRedirect from "../pages/TestPortals/TestPortalHostRedirect";

export const Route = createFileRoute("/portal/$token")({
  component: TestPortalHostRedirect,
});
